import token from './token';
import state from './state';

export default [token, state].filter((x) => !!x);
